export default __webpack_public_path__ + "static/media/GPT4_logo.bd139b0c.png";